import React, { useState, useEffect, lazy, Suspense } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../../layout/css/WidgetBrands.css";
import axios from "axios";



const LeadForm = ({ onClose }) => {
  const [captchaError, setCaptchaError] = useState("");
  const [formData, setFormData] = useState({
    kyc_name: "",
    kyc_email: "",
    kyc_mobile: "",
    kyc_city: "",
    hearing_aid_status: "",
    appointment_location: "",
    ref_url: window.location.href,
    recaptchaToken: "",
    gclid_field:"",
    gbraid: "",
    utm_source: "",
    utm_campaign: "",
    utm_term: "",
    source: "New",
    lead_quality: "3",
   
  });
  const [loading, setLoading] = useState(false);
 const [alert, setAlert] = useState("");

  const cities = [
    "Delhi", "Noida", "Greater Noida", "Ghaziabad", "Gurugram", "Faridabad",
    "Karnal", "Ambala", "Chandigarh", "Gurgaon", "Hoshiarpur", "Jalandhar", "Ludhiana",
    "Amritsar", "Bathinda", "Agra", "Prayagraj", "Lucknow", "Kanpur",
    "Moradabad", "Dehradun", "Jaipur", "Vadodara", "Gandhi Nagar", "Surat",
    "Ahmedabad", "Anand", "Jammu", "Kolkata", "Mumbai", "Kerala", "Bengaluru"
  ];

  // ✅ GCLID detection useEffect
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get("gclid");
    const gbraid = urlParams.get("gbraid");
    const utm_source = urlParams.get("utm_source");
    const utm_campaign = urlParams.get("utm_campaign");
    const utm_term = urlParams.get("utm_term");

    let finalGclid =
      gclid || JSON.parse(localStorage.getItem("gclid") || "{}").value;
      let finalGbraid =
      !finalGclid
      ? gbraid || JSON.parse(localStorage.getItem("gbraid") || "{}")?.value || ""
      : "";
      let finalUtmSource =
      utm_source || JSON.parse(localStorage.getItem("utm_source") || "{}").value;
      let finalUtmCampaign =
      utm_campaign || JSON.parse(localStorage.getItem("utm_campaign") || "{}").value;
      let finalUtmTerm =
      utm_term || JSON.parse(localStorage.getItem("utm_term") || "{}").value;


    if (finalGclid) {
      setFormData((prev) => ({
        ...prev,
        gclid_field: finalGclid,
        gbraid: finalGbraid,
        utm_source: finalUtmSource,
        utm_campaign: finalUtmCampaign,
        utm_term: finalUtmTerm
      }));
      console.log("✅ UTM detected:", finalGclid, finalGbraid, finalUtmSource, finalUtmCampaign, finalUtmTerm);
    } else {
      console.warn("⚠️ No GCLID found in URL or localStorage");
    }
  }, []);

  useEffect(() => {
    const url = window.location.href;
    const match = url.match(/hearing-aids-(price|centre|info)-([a-z\-]+)/i);

    if (match) {
      const extractedCity = decodeURIComponent(match[2].replace(/-/g, " ")).trim();

      // Capitalize first letter for consistency with city options
      const formattedCity = extractedCity
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());

      // Ensure city is part of the predefined list
      if (cities.some(city => city.toLowerCase() === formattedCity.toLowerCase())) {
        setFormData((prev) => ({
          ...prev,
          kyc_city: formattedCity,
        }));
        console.log("✅ City auto-filled successfully:", formattedCity);
      } else {
        console.warn(`⚠️ City "${formattedCity}" not found in the predefined list.`);
      }
    } else {
      console.warn("⚠️ No city match found in the URL.");
    }
  }, []);
  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  };
  const handleRecaptcha = (token) => {
    setFormData((prevData) => ({
      ...prevData,
      recaptchaToken: token
    }));
  };

 const sendEmails = async () => {
  try {
    const response = await fetch("https://www.soundforlife.in/send_email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const text = await response.text();
    console.log("Raw Response:", text);

    const result = JSON.parse(text);

    if (!result.success) {
      alert("Failed to send email");
    }
  } catch (error) {
    console.error("Error sending email:", error);
  }
};

  const handleSubmit = async (e) => {
 
    e.preventDefault();
      if (!formData.recaptchaToken) {
    setCaptchaError("⚠️Please verify the reCAPTCHA before submitting.");
    return;
  } else {
    setCaptchaError(""); // clear error if solved
  }

  setLoading(true);

    try {
      console.log("✅ Form submitted:", formData);
      const apiToken = "7bd306468c014bb278a09dd8f5cd5493";
      const apiUrl = "https://erp.soundforlife.in/api/leads.php";

      const params = new URLSearchParams({
        token: apiToken,
        name: formData.kyc_name,
        email: formData.kyc_email,
        mobile: formData.kyc_mobile,
        city: formData.kyc_city,
        ref_url: formData.ref_url,
        appointment_location: formData.appointment_location,
        hearing_aid_status: formData.hearing_aid_status,
        source: formData.source,
        lead_quality: formData.lead_quality,
        gclid_field: formData.gclid_field,
        gbraid: formData.gbraid,
        utm_source: formData.utm_source,
        utm_campaign: formData.utm_campaign,
        utm_term: formData.utm_term,
      
      });
   // ✅ Detect city from URL
    let city = null;
    const pattern = /hearing-aids-(price|centre|info)-(kolkata|gurgaon|gurugram)/i;
    const match = window.location.href.match(pattern);

    if (match) {
      city = match[2].toLowerCase();
    }

    // ✅ Default thank you
    let thankYouPage = "/thankyou";

    if (city === "kolkata") {
      thankYouPage = "/thank-you-kolkata";
    } else if (city === "gurgaon") {
      thankYouPage = "/thank-you-gurgaon";
    }

      await axios.put(`${apiUrl}?${params.toString()}`, null, {
        headers: { "Content-Type": "application/json" },
      });

      await sendEmails();

      setAlert(" ✅ Your request has been submitted successfully!" );
          // ✅ Push data to GTM and log to console
window.dataLayer = window.dataLayer || [];
const eclData = {
  event: "offline_ecl_submit",
  form_name: "Short Lead Form",
  user_name: formData.kyc_name || "",
  user_phone: "+91" + formData.kyc_mobile.replace(/\D/g, '').trim(),
  user_email: formData.kyc_email.toLowerCase().trim(),
  city: formData.kyc_city || "",
  gclid: formData.gclid_field || "",
  source: "Website Form",
};

// Push to GTM
window.dataLayer.push(eclData);

// 👇 Log it in the browser console (for testing)
console.log("🟢 ECL data sent to GTM:", eclData);
      setLoading(false);

    

      setTimeout(() => {
        
        window.location.href = `https://www.ads.soundforlife.in${thankYouPage}`;
      }, 2000);
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      setAlert("Submission failed. Please try again.");
    }
  };
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-btn" onClick={onClose}>X</button>
        <form onSubmit={handleSubmit}>
          <h2>Get Personalized Hearing Solutions – Start Your Journey Today!</h2>
          <input type="text" name="kyc_name" placeholder="Name" required onChange={handleChange} />
            <input type="hidden" id="gclid_field" name="gclid_field" value={formData.gclid_field} />
            <input type="hidden" id="gbraid" name="gbraid" value={formData.gbraid} />
            <input type="hidden" id="utm_source" name="utm_source" value={formData.utm_source} />
            <input type="hidden" id="utm_campaign" name="utm_campaign" value={formData.utm_campaign} />
            <input type="hidden" id="utm_term" name="utm_term" value={formData.utm_term} />
         <input
  type="email"
  name="kyc_email"
  placeholder="Email"
  autoComplete="email"
  onChange={handleChange}
  onBlur={(e) => {
    e.target.value = e.target.value.toLowerCase().trim();
  }}
/>
         <input
  type="tel"
  name="kyc_mobile"
  placeholder="Mobile Number"
  autoComplete="tel"
  inputMode="numeric"
  pattern="[0-9]{10}"
  maxLength="10"
  required
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 10) {
      handleChange({
        target: {
          name: 'kyc_mobile',
          value: value
        }
      });
    }
  }}
/>

          <select name="kyc_city" value={formData.kyc_city} required onChange={handleChange}>
            <option value="">Select City</option>
            {cities.map((city, index) => (
              <option key={index} value={city}>{city}</option>
            ))}
          </select>

          <select name="hearing_aid_status" required onChange={handleChange}>
            <option value="">Are you looking to buy or exchange?</option>
            <option value="Buy a new hearing aid">Buy</option>
            <option value="Exchange an old hearing aid">Exchange</option>
          </select>

          <select name="appointment_location" required onChange={handleChange}>
            <option value="">Appointment Location</option>
            <option value="Appointment At home">At Home</option>
            <option value="Appointment At clinic">At Clinic</option>
          </select>

 <div className="mt-3">
  <ReCAPTCHA
    sitekey="6Le23hohAAAAAM3nSbdRQ2LRG7V4ydhnToxBCva7"
    onChange={handleRecaptcha}
  />
  {captchaError && (
    <p style={{ color: "red", marginTop: "2px" }}>{captchaError}</p>
  )}
</div>
           <button
  type="submit"
  disabled={loading}   // sirf submit ke time disable
  className="download-btn me-2"
>
  <i className="fa-solid fa-calendar-plus me-2"></i>
  {loading ? "Submitting..." : "Book a Hearing Aid Appointment"}
</button>
          {loading && <p className="text-green-500 mt-2">⏳ Please wait...</p>}
{alert && (
  <p className="mt-2" style={{ color: 'green' }}>
    {alert}
  </p>
)}

        </form>
      </div>
    </div>
  );
};

export default LeadForm;